

































































































































































































































































import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    getUniqueId,
    getIndexFromList
} from '../../core/utils';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import CreateSlot from './CreateSlot.vue';
import CreateUnityTypeAndVar from './CreateUnityTypeAndVar.vue';
import {
    MsgBox,
    Combobox,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { NormsServices } from '../api/NormsServices';
import Loading from 'vue-loading-overlay';
import { config } from 'rxjs';
import Input from '../../core/components/Input.vue';

@Component({
    components: {
        multiselect,
        Loading,
        Combobox,
        PlusEyeButtons,
        Breadcrums,
        CreateSlot,
        CreateUnityTypeAndVar,
        CloseConfirmationModal,
        Input
    }
})
export default class CreateParameter extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() visible: boolean;
    @Prop() currentAction: string;
    @Prop() protocolTypes: any;
    @Prop() patchData: any;
    @Prop() editingEcu: boolean;
    @Prop() varDefOptions: any;
    @Prop() slotOptions: any;
    @Prop() unityOptions: any;
    @Prop() editing: boolean;
    @Prop() editingFrame: boolean;
    @Prop() visibleFrameFromList: boolean;
    @Prop() visibleFrameFromDatabase: boolean;
    visibleCloseConfirmationModal: boolean = false;
    typeOfDataOptions: any = {};
    printingTypeOptions: any = {};
    endiannessTypeOptions: any = {};
    editingSlot: boolean = false;
    editingUTV: boolean = false;
    visibleModalCreateParameter: boolean = false;
    visibleModalCreateSlot: boolean = false;
    visibleModalCreateUTV: boolean = false;
    paramDescription: string = '';
    paramPrivateDescription: string = '';
    pendingRequest: boolean = false;
    submitButtonText: string = '';
    modalTitle: string = '';
    actionModalUTV: string = '';
    patchDataSlot: any = {};
    patchDataUTV: any = {};

    booleanOptions: any = [
        {
            value: true,
            description: 'true'
        },
        {
            value: false,
            description: 'false'
        }
    ];
    //select options
    publicOptions: any = this.booleanOptions;
    alarmOptions: any = this.booleanOptions;
    trackingOptions: any = this.booleanOptions;

    //select models
    variableDefSelected: any | null = null;
    slotSelected: any | null = null;
    variableTypeSelected: any | null = null;
    unitySelected: any | null = null;
    publicSelected: any | null = null;
    alarmSelected: any | null = null;
    trackingSelected: any | null = null;

    //select reset value
    resetVarDefValue: boolean = false;
    resetSlotValue: boolean = false;
    resetVarTypeValue: boolean = false;
    resetUnityValue: boolean = false;
    resetPublicValue: boolean = false;
    resetAlarmValue: boolean = false;
    resetTrackingValue: boolean = false;

    startingBit: any = 1;
    startingByte: any = 1;
    minValue: any = null;
    maxValue: any = null;
    defaultValue: any = null;

    slotDataLoaded: boolean = false;

    //Breadcrums
    breadcrumsItems: any = [];

    get unityTypeAndVarBreadcrums() {
        let breadcrumsOptions = [
            {
                text: this.visibleFrameFromList ? 'Listado de Frames' : 'Listado de ECUs',
                disabled: false,
                href: '',
                active: false,
                action: 'goToEcuList'
            },
            {
                text: !this.editingEcu ? 'Crear Ecu' : 'Modificar ECU',
                disabled: false,
                href: '',
                active: false,
                action: 'goToEcuDialog'
            },
            {
                text: this.editingFrame ? 'Modificar frame' : 'Crear frame',
                disabled: false,
                href: '',
                active: false,
                action: 'goToFrameDialog'
            },
            {
                text: this.editing ? 'Modificar Parámetro' : 'Agregar parámetro',
                disabled: false,
                href: '',
                active: false,
                action: 'back'
            },
            {
                text: this.editing ? 'Modificar ' + this.actionModalUTV : ' Crear ' + this.actionModalUTV,
                disabled: false,
                href: '',
                active: true,
                action: null
            }
        ];

        if (this.visibleFrameFromList) {
            breadcrumsOptions.splice(1, 1);
        }

        return breadcrumsOptions;
    }

    //methods
    mounted() {
        this.visibleModalCreateParameter = this.visible;

        EventBus.$on(TypeEventBus.NORMS_ECU_DIALOG_VISIBLE, () => {
            this.closeModal();
        });

        EventBus.$on(TypeEventBus.NORMS_FRAMES_DIALOG_VISIBLE, () => {
            this.closeModal();
        });

        EventBus.$on(TypeEventBus.NORMS_FRAMES_DIALOG_CLOSE_CHILDREN_COMPONENTS, () => {
            this.closeModal();
        });

        EventBus.$on(TypeEventBus.NORMS_ADD_UNITY_VAR_CLASSIFICATION, newUnity => {
            this.addNewUnity(newUnity);
        });

        EventBus.$on(TypeEventBus.NORMS_UPDATE_UNITY_VAR_CLASSIFICATION, newUnity => {
            this.updateUnity(newUnity);
        });

        if (this.editing) {
            this.submitButtonText = 'Modificar parámetro';
            this.modalTitle = 'Modificar parámetro';
            // this.modalTitle = 'Modificar parámetro' + ' <b> - ' + this.patchData['description'] + '</b>';
            this.loadPatchData();
        } else {
            this.submitButtonText = 'Agregar parámetro';
            this.modalTitle = 'Agregar parámetro';
        }

        this.setSlotModalData();
        this.orderSlotList();
        this.orderVariableDefList();
        this.orderUnityList();
    }

    updateStartingBit(value){
        this.startingBit = value;
    }
    updateStartingByte(value){
        this.startingByte = value;
    }

    setSlotModalData() {
        this.typeOfDataOptions = this.convertDictionaryToList(this.$_getNormsProperties['all_slot_types']);
        this.printingTypeOptions = this.convertDictionaryToList(this.$_getNormsProperties['all_slot_printing_types']);
        this.endiannessTypeOptions = this.convertDictionaryToList(
            this.$_getNormsProperties['all_slot_endianess_types']
        );
        this.slotDataLoaded = true;
    }

    convertDictionaryToList(obj) {
        let items: any = [];
        for (let i = 0; i < Object.keys(obj).length; i++) {
            items.push({
                id: Object.keys(obj)[i],
                value: Object.values(obj)[i]
            });
        }
        items.sort(sortObjectByPropertyName('value'));
        return items;
    }

    getDataFromNormsProperties(option) {
        return this.$_getNormsProperties[option];
    }

    loadPatchData() {
        // this.paramDescription = this.patchData['description'];
        // if(this.patchData && this.patchData['private_description']){
        //     this.paramPrivateDescription = this.patchData['private_description'];
        // }
        this.variableDefSelected = this.patchData['variable_definition'];
        this.slotSelected = this.patchData['slot'];

        let indexUnityInOptions = getIndexFromList(this.unityOptions, 'id', this.patchData['unit']['id']);
        if (indexUnityInOptions !== -1) {
            this.unitySelected = this.unityOptions[indexUnityInOptions];
        }

        this.startingBit = this.patchData['starting_bit_delimiter'];
        this.startingByte = this.patchData['starting_byte'];
    }

    triggerAction() {
        if (this.unitySelected == null) {
            this.unitySelected = {
                id: 1,
                description: ' - '
            };
        }
        let variableTypeOption;

        if (this.variableTypeSelected !== null || this.variableTypeSelected !== undefined) {
            variableTypeOption = this.variableTypeSelected;
        } else {
            variableTypeOption = null;
        }
        let paramData = {
            unit: this.unitySelected,
            tipo: variableTypeOption,
            // "valor_minimo": this.minValue,
            // "valor_maximo": this.maxValue,
            // "frame": 6,
            starting_bit_delimiter: this.startingBit,
            starting_byte: this.startingByte,
            slot: this.slotSelected,
            variable_definition: this.variableDefSelected
        };
        if (!this.editing) {
            this.$set(paramData, 'id', getUniqueId());
            this.$emit('add-parameter', paramData);
        } else {
            // console.log("update parameter");
            this.$set(paramData, 'id', this.patchData['id']);
            this.$emit('update-parameter', this.patchData['id'], paramData);
        }
        this.closeModal();
    }

    pendingGenerateProtocol(value) {
        this.pendingRequest = value;
    }

    updateVarDefSelected(option) {
        this.variableDefSelected = option;
    }

    updateVarDefResetValue(value) {
        this.resetVarDefValue = value;
    }

    updateSlotSelected(option) {
        this.slotSelected = option;
    }

    updateSlotResetValue(value) {
        this.resetSlotValue = value;
    }

    updateVarTypeSelected(option) {
        this.variableTypeSelected = option;
    }

    updateVarTypeResetValue(value) {
        this.resetVarTypeValue = value;
    }

    updateUnitySelected(option) {
        this.unitySelected = option;
    }

    updateUnityResetValue(value) {
        this.resetUnityValue = value;
    }

    updatePublicSelected(option) {
        this.publicSelected = option;
    }

    updatePublicResetValue(value) {
        this.resetPublicValue = value;
    }

    updateAlarmSelected(option) {
        this.alarmSelected = option;
    }

    updateAlarmResetValue(value) {
        this.resetAlarmValue = value;
    }

    updateTrackingSelected(option) {
        this.trackingSelected = option;
    }

    updateTrackingResetValue(value) {
        this.resetTrackingValue = value;
    }

    createSlot() {
        this.editingSlot = false;
        this.visibilityModalCreateSlot(true);
    }

    modifySlot() {
        let self = this;
        this.editingSlot = true;
        let slotId = this.slotSelected['id'];
        NormsServices.getSlotDetail(slotId)
            .then(response => {
                self.patchDataSlot = response;
                self.visibilityModalCreateSlot(true);
            })
            .catch(error => {
                // self.handleCatchResponse(error);
            });
    }

    addNewSlot(newSlot) {
        let slotToAdd = {
            id: newSlot['id'],
            type_of_data: newSlot['type_of_data'],
            length: newSlot['length'],
            printing_type: newSlot['printing_type'],
            delimiter_char: newSlot['delimiter_char'],
            endianness_type: newSlot['endianness_type'],
            order: newSlot['order'],
            coeficients: newSlot['coeficients'],
            description: newSlot['description']
        };
        this.slotOptions.push(slotToAdd);
        this.slotSelected = slotToAdd;
        this.orderSlotList();
        this.$_successPatchRecipients('Slot agregado');
    }

    updateSlot(updatedSlot) {
        let indexSlotToUpdate = getIndexFromList(this.slotOptions, 'id', updatedSlot['id']);
        this.$set(this.slotOptions[indexSlotToUpdate], 'id', updatedSlot['id']);
        this.$set(this.slotOptions[indexSlotToUpdate], 'type_of_data', updatedSlot['type_of_data']);
        this.$set(this.slotOptions[indexSlotToUpdate], 'length', updatedSlot['length']);
        this.$set(this.slotOptions[indexSlotToUpdate], 'printing_type', updatedSlot['printing_type']);
        this.$set(this.slotOptions[indexSlotToUpdate], 'delimiter_char', updatedSlot['delimiter_char']);
        this.$set(this.slotOptions[indexSlotToUpdate], 'endianness_type', updatedSlot['endianness_type']);
        this.$set(this.slotOptions[indexSlotToUpdate], 'order', updatedSlot['order']);
        this.$set(this.slotOptions[indexSlotToUpdate], 'coeficients', updatedSlot['coeficients']);
        this.$set(this.slotOptions[indexSlotToUpdate], 'description', updatedSlot['description']);
        this.orderSlotList();
        this.$_successPatchRecipients('Slot modificado');
    }

    orderSlotList() {
        this.slotOptions.sort(sortObjectByPropertyName('description'));
    }

    orderVariableDefList() {
        this.varDefOptions.sort(sortObjectByPropertyName('description'));
    }

    orderUnityList() {
        this.unityOptions.sort(sortObjectByPropertyName('description'));
    }

    visibilityModalCreateSlot(value) {
        this.visibleModalCreateSlot = value;
    }

    visibilityModalCreateUTV(value) {
        this.visibleModalCreateUTV = value;
    }

    addNewVariableDef(newVarDef) {
        this.varDefOptions.push(newVarDef);
        this.variableDefSelected = newVarDef;
        this.orderVariableDefList();
        this.$_successPatchRecipients('Variable Definition agregada');
    }

    addNewUnity(newUnity) {
        this.unityOptions.push(newUnity);
        this.unitySelected = newUnity;
        this.orderUnityList();
        this.$_successPatchRecipients('Unidad agregada');
    }

    updateVarDef(updatedVarDef) {
        let indexVarDef = getIndexFromList(this.varDefOptions, 'id', updatedVarDef['id']);
        this.$set(this.varDefOptions[indexVarDef], 'id', updatedVarDef['id']);
        this.$set(this.varDefOptions[indexVarDef], 'description', updatedVarDef['description']);
        this.$set(this.varDefOptions[indexVarDef], 'private_description', updatedVarDef['private_description']);
        this.orderVariableDefList();
        this.$_successPatchRecipients('Variable Definition modificada');
    }

    updateUnity(updatedUnity) {
        let indexUnity = getIndexFromList(this.unityOptions, 'id', updatedUnity['id']);
        this.$set(this.unityOptions[indexUnity], 'id', updatedUnity['id']);
        this.$set(this.unityOptions[indexUnity], 'description', updatedUnity['description']);
        this.orderUnityList();
        this.$_successPatchRecipients('Unidad modificada');
    }

    closeModal() {
        this.$emit('close-modal', false);
        this.visibilityCloseConfirmationModal(false);
    }

    showCloseConfirmationModal() {
        this.visibilityCloseConfirmationModal(true);
    }

    visibilityCloseConfirmationModal(value) {
        this.visibleCloseConfirmationModal = value;
    }

    handleListenKey(value: boolean) {
        if (value) {
            this.$_disableListenkey();
        } else {
            this.$_enableListenkey();
        }
    }

    labelWithPrivateDescription({ description, private_description }) {
        if (private_description == null || private_description === ' ') {
            private_description = '';
        }
        if (private_description !== '') {
            return `${description} - ${private_description}`;
        } else {
            return `${description}`;
        }
    }

    get getBreadcrumsItems() {
        let breadcrumsOptions: any = [];
        if (this.visibleFrameFromDatabase) {
            breadcrumsOptions = [
                {
                    text: 'Listado de Databases',
                    disabled: false,
                    href: '',
                    active: false,
                    action: 'goToDatabaseList'
                },
                {
                    text: this.editingFrame ? 'Modificar frame' : 'Crear frame',
                    disabled: false,
                    href: '',
                    active: false,
                    action: 'back'
                },
                {
                    text: this.editing ? 'Modificar parámetro' : 'Agregar parámetro',
                    disabled: false,
                    href: '',
                    active: true,
                    action: null
                }
            ];
        } else {
            breadcrumsOptions = [
                {
                    text: this.visibleFrameFromList ? 'Listado de Frames' : 'Listado de ECUs',
                    disabled: false,
                    href: '',
                    active: false,
                    action: 'goToEcuList'
                },
                {
                    text: !this.editingEcu ? 'Crear Ecu' : 'Modificar ECU',
                    disabled: false,
                    href: '',
                    active: false,
                    action: 'goToEcuDialog'
                },
                {
                    text: this.editingFrame ? 'Modificar frame' : 'Crear frame',
                    disabled: false,
                    href: '',
                    active: false,
                    action: 'back'
                },
                {
                    text: this.editing ? 'Modificar parámetro' : 'Agregar parámetro',
                    disabled: false,
                    href: '',
                    active: true,
                    action: null
                }
            ];

            if (this.visibleFrameFromList) {
                breadcrumsOptions.splice(1, 1);
            }
        }

        return breadcrumsOptions;
    }

    get checkIfFormIsValid() {
        if (
            this.variableDefSelected !== null &&
            this.slotSelected !== null &&
            this.startingBit !== '' &&
            this.startingBit >= 1 &&
            this.startingByte !== '' &&
            this.startingByte >= 1
        ) {
            return true;
        } else {
            return false;
        }
    }

    getFinalizationValue(finalization) {
        if (finalization !== null) {
            if (finalization['id'] !== -1) {
                return finalization['id'];
            } else {
                return null;
            }
        } else {
            return null;
        }
    }

    getInitializationValue(initialization) {
        if (initialization !== null) {
            if (initialization['id'] !== -1) {
                return initialization;
            } else {
                return null;
            }
        } else {
            return null;
        }
    }

    createUTV(action) {
        this.patchDataUTV = {};
        this.editingUTV = false;
        this.actionModalUTV = action;
        this.visibilityModalCreateUTV(true);
    }

    modifyUTV(action) {
        let self = this;
        this.editingUTV = true;
        this.actionModalUTV = action;
        let id;

        if (action === 'Variable Definition') {
            id = this.variableDefSelected['id'];
            NormsServices.getVariableDefinitionDetail(id)
                .then(response => {
                    self.assignPatchUTVData(response);
                })
                .catch(error => {
                    // self.handleCatchResponse(error);
                });
        } else if (action === 'Unidad') {
            id = this.unitySelected['id'];
            NormsServices.getUnidadDetail(id)
                .then(response => {
                    self.assignPatchUTVData(response);
                })
                .catch(error => {
                    // self.handleCatchResponse(error);
                });
        }
    }

    assignPatchUTVData(response) {
        let self = this;
        self.patchDataUTV = response;
        self.visibilityModalCreateUTV(true);
    }

    validateStartingBytes(value) {
        if (value >= 1) {
            return true;
        } else {
            return 'Debe ser mayor o igual a 1';
        }
    }
}
